export interface BaseControlProps {
    name: BaseControlName;
    contentId: string;

    onClick?: () => void;
}

export enum BaseControlName {
    PLAY = 'play',
    NEXT_EPISODE = 'next_episode',
    SOUND = 'sound',
    EPISODE_LIST = 'episode_list',
    AUDIO_SUBS_LIST = 'audio_subs_list',
    ADJUSTMENT = 'adjustment',
    FULLSCREEN = 'fullscreen',
    CLOSE = 'close',
    STREAMING = 'streaming',
    FORWARD = 'forward',
    BACKWARD = 'backward',
    CHANNEL_PROGRAM = 'channel_program',
}
